/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export interface Menu {
  id: number;
  name: string;
  active: boolean;
  route: string;
}

interface MenuContextType {
  listMenu: Menu[];
  updateListMenu: (menuId: number) => void;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

const listDefault: Menu[] = [
  { id: 1, name: 'Dashboard', active: true, route: '/dashboard' },
  { id: 2, name: 'Enviar Eventos', active: false, route: '/send-event' },
  { id: 3, name: 'Usuários', active: false, route: '/users' },
];

import { useLocation } from 'react-router-dom';

export const MenuProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const getInitialMenu = () => {
    const raw = sessionStorage.getItem('listMenu');
    return raw ? (JSON.parse(raw) as Menu[]) : listDefault;
  };

  const [listMenu, setListMenu] = useState<Menu[]>(getInitialMenu());
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const currentPath = location.pathname;
    const menuActive = listMenu.find((item) => item.route === currentPath);
    if (!menuActive?.active) {
      const updatedMenu = listMenu.map((item) =>
        item.route === currentPath ? { ...item, active: true } : { ...item, active: false },
      );
      setListMenu(updatedMenu);
      sessionStorage.setItem('listMenu', JSON.stringify(updatedMenu));
    }
    // eslint-disable-next-line
  }, [location.pathname]);

  const updateListMenu = (menuId: number) => {
    const updateList = listMenu.map((item) =>
      item.id === menuId ? { ...item, active: true } : { ...item, active: false },
    );
    setListMenu(updateList);
    sessionStorage.setItem('listMenu', JSON.stringify(updateList));
    const menu = updateList.find((item) => item.id === menuId);
    if (menu?.active) {
      navigate(menu.route);
    }
  };

  return (
    <MenuContext.Provider value={{ listMenu, updateListMenu }}>{children}</MenuContext.Provider>
  );
};

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error('useMenu must be used within an MenuProvider');
  }
  return context;
};
